import { Loader2, RefreshCw, AlertCircle } from "lucide-react";

export function LoadingState({ label = "Loading…", className = "" }) {
  return (
    <div
      className={`flex items-center justify-center gap-2 text-slate-500 py-16 ${className}`}
      data-testid="loading-state"
      role="status"
    >
      <Loader2 className="w-4 h-4 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function RetryState({
  title = "We couldn't load this just now.",
  body = "The server may be briefly restarting. Please try again in a moment.",
  onRetry,
  testId = "retry-state",
  className = "",
}) {
  return (
    <div
      className={`rounded-3xl border border-dashed border-slate-200 bg-white p-8 sm:p-10 text-center ${className}`}
      data-testid={testId}
      role="alert"
    >
      <div className="w-10 h-10 mx-auto rounded-2xl bg-slate-100 grid place-items-center">
        <AlertCircle className="w-4 h-4 text-[#0A2540]" />
      </div>
      <div className="font-display text-2xl text-[#0A2540] mt-3">{title}</div>
      <p className="mt-2 text-sm text-slate-600 max-w-md mx-auto leading-relaxed">
        {body}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          data-testid={`${testId}-retry-btn`}
          className="mt-5 inline-flex items-center gap-2 bg-[#0A2540] text-white rounded-full px-5 py-2.5 text-sm font-semibold hover:bg-[#051A2E] transition-colors active:scale-95"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          Retry
        </button>
      )}
    </div>
  );
}
